module.exports = __webpack_public_path__ + "img/line-footer.03aa56a8.svg";